<template>
  <div class="Google">     
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" viewBox="0 0 512 512">
            <defs>
                <clipPath id="clip-Custom_Size_1">
                    <rect width="512" height="512"/>
                </clipPath>
            </defs>
            <g id="Custom_Size_1" data-name="Custom Size – 1" clip-path="url(#clip-Custom_Size_1)">
                <g id="logo-google-playstore-svgrepo-com" transform="translate(87.81 59.026)">
                    <path id="Path_1" data-name="Path 1" d="M48,58.353V347.8a3.189,3.189,0,0,0,5.428,2.261L204.137,203.081,53.428,56.091A3.189,3.189,0,0,0,48,58.353Z" transform="translate(0 -6.107)"/>
                    <path id="Path_2" data-name="Path 2" d="M276.469,136.582,87.5,32.471l-.118-.066c-3.255-1.768-6.349,2.637-3.682,5.2L231.83,179.247Z" transform="translate(-9.14)"/>
                    <path id="Path_3" data-name="Path 3" d="M83.715,421.708c-2.681,2.563.412,6.967,3.682,5.2l.118-.066L276.471,322.73l-44.639-42.68Z" transform="translate(-9.143 -65.363)"/>
                    <path id="Path_4" data-name="Path 4" d="M412.748,220.6l-52.77-29.062L310.36,239.014l49.618,47.452,52.77-29.04C427.1,249.495,427.1,228.534,412.748,220.6Z" transform="translate(-69.133 -42.04)"/>
                </g>
               <!--  <g id="Path_5" data-name="Path 5" fill="none">
                    <path d="M256,0C397.385,0,512,114.615,512,256S397.385,512,256,512,0,397.385,0,256,114.615,0,256,0Z" stroke="none"/>
                    <path d="M 256 16 C 123.66357421875 16 16 123.66357421875 16 256 C 16 388.33642578125 123.66357421875 496 256 496 C 388.33642578125 496 496 388.33642578125 496 256 C 496 123.66357421875 388.33642578125 16 256 16 M 256 0 C 397.3849182128906 0 512 114.6150817871094 512 256 C 512 397.3849182128906 397.3849182128906 512 256 512 C 114.6150817871094 512 0 397.3849182128906 0 256 C 0 114.6150817871094 114.6150817871094 0 256 0 Z" stroke="none" fill="#000"/>
                </g> -->
            </g>
        </svg>
    </div>
</template>

<script>

import gsap from "gsap"
export default {
  name: 'Google',
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Google
    position relative
    display flex 
    align-items center
    justify-content center

    background white
    border-radius 50%
    border 1px solid black

    
    & svg
        width 100%
        .cls-1
            fill none
            stroke #222221
            stroke-miterlimit 10
            stroke-width 1.5px 
        .cls-2
            fill #222221
</style>


